import { addMarks } from "./methods/addMarks.js";
import { canToggleMark } from "./methods/canToggleMark.js";
import { closest } from "./methods/closest.js";
import { closestBlockEntry } from "./methods/closestBlockEntry.js";
import { closestViableBlockContainerEntry } from "./methods/closestViableBlockContainerEntry.js";
import { ejectElement } from "./methods/ejectElement.js";
import { elementToSpecifics } from "./methods/elementToSpecifics.js";
import { getElementDataAttributes } from "./methods/getElementDataAttributes.js";
import { getPreviousSibling } from "./methods/getPreviousSibling.js";
import { hasMarks } from "./methods/hasMarks.js";
import { hasParentOfType } from "./methods/hasParentOfType.js";
import { isElementType } from "./methods/isElementType.js";
import { permissivelyDeserializeNodes } from "./methods/permissivelyDeserializeNodes.js";
import { removeMarks } from "./methods/removeMarks.js";
import { serializeNodes } from "./methods/serializeNodes.js";
import { strictlyDeserializeNodes } from "./methods/strictlyDeserializeNodes.js";
import { textToSpecifics } from "./methods/textToSpecifics.js";
import { toLatestFormat } from "./methods/toLatestFormat.js";
import { topLevelNodes } from "./methods/topLevelNodes.js";
const ContemberEditor = {
  addMarks,
  canToggleMark,
  closest,
  closestBlockEntry,
  closestViableBlockContainerEntry,
  ejectElement,
  elementToSpecifics,
  getElementDataAttributes,
  getPreviousSibling,
  hasMarks,
  hasParentOfType,
  isElementType,
  permissivelyDeserializeNodes,
  removeMarks,
  serializeNodes,
  strictlyDeserializeNodes,
  textToSpecifics,
  toLatestFormat,
  topLevelNodes
};
export {
  ContemberEditor
};
//# sourceMappingURL=index.js.map
